var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("appointment-management", {
    ref: "AppointmentManagement",
    attrs: {
      "academic-years": _vm.academicYears,
      "can-show-confirm-appointment": false,
      "can-show-denied-appointment": false,
      "can-show-recoordinate-appointment": false,
      "can-show-service-filter": _vm.canShowServiceFilter,
      "can-show-write-evaluation-action": _vm.canShowWriteEvaluationAction,
      "cancel-appointment": _vm.cancelAppointment,
      "change-center-appointment": _vm.changeCenterAppointment,
      companies: _vm.companiesData,
      "deny-appointment": _vm.denyAppointment,
      "full-profile": _vm.fullProfileData,
      "get-academic-years": _vm.getAcademicYears,
      "get-appointment-filters": _vm.getAppointmentFilters,
      "get-appointments": _vm.getAppointments,
      "get-appointments-specialists": _vm.getAppointmentsSpecialists,
      "get-centers": _vm.getCenters,
      "get-discipline-types": _vm.getDisciplineTypes,
      "get-districts": _vm.getDistricts,
      "get-municipalities": _vm.getMunicipalities,
      "get-reasons-appointment-status": _vm.getReasonsApointmentStatus,
      "get-reasons-appointment-status-detail":
        _vm.getReasonsApointmentStatusDetail,
      "get-schools": _vm.getSchools,
      "get-service-locations": _vm.getServiceLocations,
      "get-type-places": _vm.getTypePlaces,
      "has-evaluation-document": _vm.hasEvaluationDocument,
      "has-permissions": _vm.hasPermissions,
      "is-provider": _vm.isProvider,
      "is-specialist": _vm.isSpecialist,
      "is-specialist-depr": _vm.isSpecialistDPER,
      "need-reason-detail": true,
      "on-download-evaluation-document": _vm.onDownloadEvaluationDocument,
      "on-download-pei": _vm.onDownloadPei,
      "on-download-referral-sheet": _vm.onDownloadReferralSheet,
      "on-get-additional-info": _vm.getAppointmentAdditionalInfo,
      "on-get-contact-information": _vm.getContactInformation,
      "on-get-therapies": _vm.getAppointmentTherapies,
      "on-replace-evaluation-document": _vm.onReplaceEvaluationDocument,
      "on-set-as-attended": _vm.setAsAttended,
      "show-view-record": _vm.allowedGoToStudentServiceRecord
    },
    on: { "redirect-view-record": _vm.handleRedirectViewAppointmentRecord }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }